module.exports = __webpack_public_path__ + "img/326.830aac8b.jpg";